export default "__VITE_ASSET__00Mv9s8Z__"